module.exports = __webpack_public_path__ + "7d8d3f42089221011a6fcb81890472d5.png";